import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// import Grid from '@mui/material/Grid';
// import SurgeonsIcon from '@mui/icons-material/LocalHospitalOutlined';

import { SurgeonsTableContainer } from '../../components/surgeons';
// import StatsBox from '../../components/shared/StatsBox';

import { fetchDistributors, fetchHospitals } from '../../actions/adminActions';
import { fetchSurgeons } from '../../actions/surgeonsActions';

import './surgeons-page.scss';

const SurgeonsPage = (props) => {
  const {
    surgeons,
    distributors,
    countryList,
    users,
    hospitals,
    companies,
    currentUserId,
    fetchDistributors,
    fetchSurgeons,
    fetchHospitals,
  } = props;

  useEffect(() => {
    fetchDistributors();
    fetchSurgeons();
    fetchHospitals();
  }, [fetchDistributors, fetchSurgeons, fetchHospitals, currentUserId]);

  // const activeSurgeons = useMemo(() => surgeons.filter((u) => !u.disabled), [surgeons]);
  // const multiFactorSurgeons = useMemo(() => surgeons.filter((u) => !!u.multiFactorEnabled), [surgeons]);

  return (
    <div className="surgeons-page">
      {/*<Grid container spacing={3} sx={{ mb: 3 }}>*/}
      {/*  <Grid size={{ xs: 12, md: 4 }}>*/}
      {/*    <StatsBox title='Total Surgeons' number={surgeons?.length} icon={<SurgeonsIcon />} />*/}
      {/*  </Grid>*/}
      {/*  <Grid size={{ xs: 12, md: 4 }}>*/}
      {/*    <StatsBox title='Active Surgeons' number={activeSurgeons?.length} icon={<SurgeonsIcon />} />*/}
      {/*  </Grid>*/}
      {/*  <Grid size={{ xs: 12, md: 4 }}>*/}
      {/*    <StatsBox title='Active Surgeons' number={multiFactorSurgeons?.length} icon={<SurgeonsIcon />} />*/}
      {/*  </Grid>*/}
      {/*</Grid>*/}
      <SurgeonsTableContainer
        surgeons={surgeons}
        distributors={distributors}
        countries={countryList}
        hospitals={hospitals}
        users={users}
        companies={companies}
        withButton
      />
    </div>
  );
};

SurgeonsPage.propTypes = {
  surgeons: PropTypes.array,
  distributors: PropTypes.array,
  fetchDistributors: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  return {
    distributors: state.distributors?.list || [],
    surgeons: state.surgeons.list,
    countryList: state.countries.list,
    users: state.users.list,
    hospitals: state.hospitals.list,
    companies: state.companies.list,
    currentUserId: state.user.currentUser?.uid,
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchDistributors: () => dispatch(fetchDistributors()),
  fetchSurgeons: () => dispatch(fetchSurgeons()),
  fetchHospitals: () => dispatch(fetchHospitals()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SurgeonsPage);
